import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LoginService } from './login.service';
import { NotificationService } from '@sharedServices/notification.service';
import { CookieStorageService } from '@sharedServices/cookie-storage.service';
import { UtilService } from '@sharedServices/util.service';
import { LOGIN } from '@sharedModels/analytics-events';
import { LoggerService } from '@sharedServices/logger.service';
import { AdminAppService } from '@sharedServices/admin-app.service';

@Injectable({
  providedIn: 'root'
})

export class LoginGuard implements CanActivate {

  constructor(
    private loginService: LoginService,
    private notificationService: NotificationService,
    private router: Router,
    private cookieStorageService: CookieStorageService,
    private utilService: UtilService,
    private loggerService: LoggerService,
    private adminAppService: AdminAppService
  ) {}

  canActivate(): boolean {
    if (this.cookieStorageService.checkCookies('webApp_activeRole', 'webApp_accessToken', 'webApp_userEmail')) {
      const activeRole = this.utilService.getCurrentActiveRole()
      this.adminAppService.getEmployeeName().subscribe((response)=>{
        let loggerObj = {
          name:response.data.employee.name,
          mobile:response.data.employee.mobile,
          email:response.data.employee.email,
          role:activeRole
        }
        this.loggerService.logToAnalyticsNoRoute(LOGIN.ADMIN_APP_LOGIN, loggerObj)
      })

      if(activeRole === 'HOSPITAL' || activeRole === 'SUB_HOSPITAL') {
        this.router.navigateByUrl('hospitalApp')
      } else if(activeRole === 'INSTITUTION') {
        this.router.navigateByUrl('institutionApp')
      } else {
        this.router.navigateByUrl('adminApp')
      }
      return false
    } else return true
  }
}
